import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes";
import store from "./redux/store";
import { Provider } from "react-redux";
import "./assets/styles/base.css";
import "./assets/styles/custom.css";
import 'antd/dist/antd.css';
import "./App.less";
import Helmet from 'react-helmet';

function App() {
  return (
    <Provider store={store}>
      <Helmet titleTemplate="SheCanCode Materials | %s" />
      <Router>
        <Routes />
      </Router>
    </Provider>
  );
}

export default App;
